import defaults from "lodash/defaults";

const confidentialValueMaskDefaultOptions = {
  replaceChar: "*",
  padStartMaxLength: 4,
  padStartFillString: "0",
};

function confidentialValueMask(value) {
  if (value === null || value === undefined || value === "") return value;

  const options = defaults(
    this?.options || {},
    confidentialValueMaskDefaultOptions
  );

  value = String(value);
  return value
    .padStart(options.padStartMaxLength, options.padStartFillString)
    .slice(-options.padStartMaxLength)
    .padStart(value.length, options.replaceChar);
}

export const phoneNumberMask = "(###) ###-####";

export function accountNumberMask(value) {
  return confidentialValueMask(value);
}
